<template>
  <div class="video-page">
    <van-nav-bar :title="$t('video.video')" />

    <van-tabs
      v-model="active"
      title-inactive-color="#e6c56a"
      title-active-color="#e6c56a"
      line-height="8px"
      line-width="40px"
      @change="onChange"
    >
      <van-tab
        :title="item.name"
        :name="item.id"
        title-style="font-size:16px;line-height:50px;"
        v-for="(item,index) in videolitem"
        :key="item.id"
        @click="toPlayVideo(item.id)"
      >
        <template #title v-if="index == 0">
          <div class="first-tab-title">
            <div>{{ item.name }}</div>
            <div class="new-mark"></div>
          </div>
        </template>

        <div>
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
              v-model="loading"
              :finished="finished"
              @load="onLoad"
            >
              <div class="list-item">
                <div
                  class="movie-list-item"
                  v-for="(i,key) in data"
                  :key="key"
                  @click="toPlayVideo(i.id)"
                >
                  <div
                    class="cover_img van-image van-image--round"
                    style="width: 100%; height: 100px;"
                  >
                    <img
                      :src="i.vod_pic"
                      class="van-image__img"
                    />
                  </div>
                  <div class="movie-list-item-bottom" style="bottom: 33px;">
                    <div class="movie-time-div">
                      <span>{{ i.vod_name }}</span>
                      <span style="font-size: 12px;">{{$t("video.play")}} :{{ i.count }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
        </div>
      </van-tab>
    </van-tabs>

    <div style="height: 55px;"></div>
  </div>
</template>

<script>
import { Toast } from "vant";

export default {
  data() {
    return {
      active: 888,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      videolitem: [],
      data: [],
      page: 0,
      id: 888,
    };
  },
  methods: {
    onLoad(isRefresh = false) {
      if (isRefresh) {
        this.page = 0;
        this.data = [];
      }

      this.loading = true;

      this.getVideoList().then(() => {
        this.loading = false;
        if (this.refreshing) {
          this.refreshing = false;
          Toast("새로고침 성공");
        }
      });
    },
    onChange(name) {
      this.id = name;
      this.finished = false;
      this.loading = true;
      this.page = 0;
      this.data = [];
      this.onLoad(true);
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.onLoad(true);
    },
    toPlayVideo(id) {
      this.$router.push({ path: "/PlayVideo", query: { id } });
    },
    getVideoList() {
      return new Promise((resolve, reject) => {
        this.$http({
          method: "get",
          data: { id: this.id, page: this.page },
          url: "video_list",
        }).then((res) => {
          if (res.data && res.data.data && res.data.data.length > 0) {
            this.data = this.data.concat(res.data.data);
            this.page++;
            resolve();
          } else {
            this.finished = true;
            resolve();
          }
        }).catch((error) => {
          console.error("Error fetching video list:", error);
          reject(error);
        });
      });
    },
    toLogin(str) {
      this.$router.push({ path: str });
    },
    getVideoClass() {
      this.$http({
        method: "get",
        url: "video_class",
      }).then((res) => {
        const lanng = localStorage.getItem("lang");
        const list = Array.isArray(res.data) ? res.data : [];
        const obj = { id: 888, name: "最新,new,最新の,new" };

        this.videolitem = [obj, ...list];

        this.videolitem.forEach((item) => {
          const oldName = item.name || "";
          const parts = oldName.split(",");

          if (parts.length > 1) {
            if (lanng == "kr") {
              item.name = parts[0] || oldName;
            } else if (lanng == "en") {
              item.name = parts[1] || parts[0] || oldName;
            } else if (lanng == "ja") {
              item.name = parts[2] || parts[0] || oldName;
            } else {
              item.name = parts[3] || parts[0] || oldName;
            }
          } else {
            item.name = oldName;
          }
        });
      });
    },
  },
  created() {
    this.getVideoClass();
  },
};
</script>

<style scoped lang="less">
.video-page {
  min-height: 100vh;
  background: #1f1d21;
  color: #e6c56a;
}

/deep/ .van-nav-bar {
  background: #1f1d21;
  box-shadow: none;
}

/deep/ .van-nav-bar::after {
  border-bottom: none;
}

/deep/ .van-nav-bar__title {
  color: #e6c56a;
  font-weight: 500;
}

/deep/ .van-tabs {
  background: #1f1d21;
}

/deep/ .van-tabs__wrap {
  height: 13vw;
  padding-bottom: 10px;
  background: #1f1d21;
}

/deep/ .van-tabs__nav {
  background: #1f1d21;
}

/deep/ .van-tab {
  color: #e6c56a !important;
}

/deep/ .van-tab__text {
  color: #e6c56a !important;
}

/deep/ .van-tabs__line {
  background-color: #e6c56a;
  border-radius: 10px;
}

/deep/ .van-loading__text {
  font-size: 32px;
  color: #e6c56a;
}

/deep/ .van-list__finished-text {
  font-size: 32px;
  color: #e6c56a;
}

/deep/ .van-pull-refresh__head {
  height: 100px;
}

/deep/ .van-pull-refresh__text {
  font-size: 32px;
  color: #e6c56a;
}

.first-tab-title {
  display: flex;
  color: #e6c56a;
}

.new-mark {
  color: #e6c56a;
  font-weight: bold;
  background: url('/img/new.png') right top 5px / 100% no-repeat;
  width: 30px;
}

.list-item {
  display: flex;
  width: calc(100% - 7vw);
  margin: 10px auto;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
}

.movie-list-item {
  width: calc(50% - 16px);
  margin-bottom: -7vw;
}

.cover_img {
  border-radius: 20px;
  overflow: hidden;
  background: #1f1d21;
}

.movie-list-item-bottom {
  position: relative;
  width: 100%;
  bottom: 6vw;
}

.movie-time-div {
  background-color: rgba(0, 0, 0, 0.4);
  height: 8vw;
  color: #fff;
  border-radius: 0 0 40px 40px;
}

.movie-list-item-bottom div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.movie-time-div span:first-child {
  overflow: hidden;
  white-space: nowrap;
  width: 24vw;
  padding-left: 16px;
  font-size: 3vw;
}

.activeBg {
  color: #e6c56a;
  font-weight: bold;
  background: url('/img/new.png') right top 5px / 30% no-repeat;
}
</style>
